import { render, staticRenderFns } from "./InsightViewPage.vue?vue&type=template&id=15c09c12&scoped=true&"
import script from "./InsightViewPage.vue?vue&type=script&lang=js&"
export * from "./InsightViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c09c12",
  null
  
)

export default component.exports